export interface GoldPriceData {
  buyPerLuong: number;   // giá mua vào (per lượng)
  sellPerLuong: number;  // giá bán ra (per lượng)
  buyPerChi: number;     // giá mua vào (per chỉ)
  sellPerChi: number;    // giá bán ra (per chỉ)
  updatedAt: Date;
}

const API_URL = 'https://api2.giavang.net/v1/gold/last-price?codes%5B%5D=BTSJC';

export async function fetchGoldPrice(): Promise<GoldPriceData | null> {
  try {
    const response = await fetch(API_URL, {
      headers: {
        'accept': 'application/json',
        'origin': 'https://giavang.net',
        'referer': 'https://giavang.net/',
      },
    });

    const json = await response.json();

    if (json.status !== 1 || !json.data?.length) {
      return null;
    }

    const btsjc = json.data[0];

    return {
      buyPerLuong: btsjc.buy,
      sellPerLuong: btsjc.sell,
      buyPerChi: btsjc.buy / 10,
      sellPerChi: btsjc.sell / 10,
      updatedAt: new Date(btsjc.update_time * 1000),
    };
  } catch (error) {
    console.error('Error fetching gold price:', error);
    return null;
  }
}
